import type { ModelVersion } from '~/features/x-ray/types/model';

import { PromptModelVersion } from '~/api/sylvanus/typedefs.autogen';
import { SearchQuery } from '~/features/advanced-search/types';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { mapTestCase } from './transformers';

export const getPromptModelVersion = async ({
  modelId,
  version,
  highlightMethod,
}: {
  modelId: Uuid;
  version: number;
  highlightMethod: string;
}): Promise<ModelVersion> => {
  const response: PromptModelVersion = await sylvanus.get(
    `/model/${modelId}/version/${version}`,
  );

  const { scope } = response.config;

  return {
    config: response.config,
    createdBy: Number(response.created_by_user_id),
    createdByEmail: response.created_by_user_email ?? null,
    //l10n-ignore: API parsing no formatting required
    createdDate: new Date(response.datetime_created),
    libraryModelId: response.library_model_info?.library_model_id,
    libraryModelVersion: response.library_model_info?.library_model_version,
    modelId: response.prompt_model_id,
    optimize: response.optimize
      ? {
          state: response.optimize.state,
          version: response.optimize.version_number,
        }
      : null,
    publishStatus: response.publish?.status ?? null,
    scope: scope ? (scope.data.attributes.query as SearchQuery) : [],
    testCases: Object.values(response.test_cases ?? []).map((testCase) =>
      mapTestCase(testCase, highlightMethod),
    ),
    version: response.version_number,
  };
};
